// import {PopupButton} from "@typeform/embed-react";
import React from "react";

export const Button = ({
  cta = "Become A Partner",
  className = "primary-cta inline-block mt-5 mb-10 md:my-9",
}) => {
  return (
    // <PopupButton
    //   id='pMLVcl8W'
    //   onReady={() => {
    //     // noop
    //   }}
    //   enableSandbox
    //   className={className}
    //   inlineOnMobile
    //   size={60}
    // >
    //   {cta}
    // </PopupButton>
    <button
      type='button'
      className={className}
      onClick={() => window.scrollTo(0, 0)}
    >
      {cta}
    </button>
  );
};
